module.exports = __webpack_public_path__ + "img/团队01.8b5acf37.svg";